export const paths = {
  profile: '/perfil',
  dream: '/sonho',
  salesGoal: '/meta-de-vendas',
  avgTicket: '/ticket-medio',
  activity: '/atividades',
  funnelComplete: '/funil-completo',
  myFunnel: '/funil',
  competences: '/competencias'
};